import { MenuItem, Select } from '@material-ui/core'
import {
  DeleteIcon,
  ActionLabel,
  TableHeader,
  WrapperDelete,
  ActionInnerGo,
  ActionWrapper,
  TableBodyCell,
  ActionContainer,
  ActionInnerStop,
  TableHeaderCell,
  StyledTextField,
  TableHeaderTimeCell,
  StyledDateTimePicker
} from './tally-sheet.styles'
import { TableRow } from '@material-ui/core'
import { TALLY_SHEET_COLUMNS } from './tally-sheet.helper'
import { Popup } from '@progress/kendo-react-popup'

const CustomPopup = (props) => {
  return <Popup {...props} style={{ zIndex: 10000 }} />
}

const ActionStart = ({ disabled, onClick }) => (
  <ActionWrapper onClick={onClick}>
    <ActionInnerGo disabled={disabled}>
      <ActionLabel>GO</ActionLabel>
    </ActionInnerGo>
  </ActionWrapper>
)
const ActionStop = ({ disabled, onClick }) => (
  <ActionWrapper onClick={onClick}>
    <ActionInnerStop disabled={disabled}>
      <ActionLabel>STOP</ActionLabel>
    </ActionInnerStop>
  </ActionWrapper>
)

export const TableHeaderCustom = () => (
  <TableHeader>
    <TableRow>
      {TALLY_SHEET_COLUMNS.filter((col) => col.field !== 'end_date').map(
        (col) =>
          col.field === 'start_date' ? (
            <TableHeaderCell
              key='time-header'
              align='center'
              colSpan={2}
              minWidth={col.width}
            >
              Time
            </TableHeaderCell>
          ) : (
            <TableHeaderCell key={col.field} rowSpan={2} minWidth={col.width}>
              {col.title}
            </TableHeaderCell>
          )
      )}
    </TableRow>
    <TableRow>
      {TALLY_SHEET_COLUMNS.filter(
        (col) => col.field === 'start_date' || col.field === 'end_date'
      ).map((col) => (
        <TableHeaderTimeCell
          align='center'
          key={col.field}
          minWidth={col.width}
        >
          {col.title}
        </TableHeaderTimeCell>
      ))}
    </TableRow>
  </TableHeader>
)

export const TableRowCustom = ({
  row,
  idx,
  onBlur,
  handleStop,
  handleStart,
  handleChange,
  handleDelete,
  materialTypes,
  uomQuantities
}) => (
  <TableRow key={idx}>
    {TALLY_SHEET_COLUMNS.map((col) => {
      const disableStart = row.disableStart || !row.product_name
      const disableStop = row.disableStop

      if (col.fieldType === 'action') {
        return (
          <TableBodyCell key={col.field} align='center'>
            <ActionContainer>
              <WrapperDelete onClick={() => handleDelete(idx)}>
                <DeleteIcon />
              </WrapperDelete>
              <ActionStart
                disabled={disableStart}
                onClick={() => handleStart(idx, disableStart)}
              />
              <ActionStop
                disabled={disableStop}
                onClick={() => handleStop(idx, disableStart)}
              />
            </ActionContainer>
          </TableBodyCell>
        )
      }
      if (col.fieldType === 'textinput' || col.fieldType === 'numberinput') {
        return (
          <TableBodyCell key={col.field}>
            <StyledTextField
              placeholder={col.title}
              name={col.field}
              type={col.fieldType === 'numberinput' ? 'number' : 'text'}
              size='small'
              fullWidth
              onBlur={() => onBlur(idx)}
              value={row[col.field]}
              disabled={(disableStart && !disableStop) || !row.product_name}
              onChange={(e) => handleChange(idx, col.field, e.target.value)}
            />
          </TableBodyCell>
        )
      }
      if (col.fieldType === 'select' && col.field === 'product_name') {
        return (
          <TableBodyCell key={col.field}>
            <Select
              fullWidth
              size='small'
              labelId='demo-simple-select-label'
              id='demo-simple-select'
              value={row[col.field]}
              label={col.title}
              disabled={disableStart && !disableStop}
              onChange={(e) => handleChange(idx, col.field, e.target.value)}
            >
              {materialTypes.map((opt) => (
                <MenuItem key={opt.product_name} value={opt.product_name}>
                  {opt.product_name}
                </MenuItem>
              ))}
            </Select>
          </TableBodyCell>
        )
      }
      if (col.fieldType === 'select' && col.field === 'uom_quantity') {
        return (
          <TableBodyCell key={col.field}>
            <Select
              fullWidth
              size='small'
              labelId='demo-simple-select-label'
              id='demo-simple-select'
              value={row[col.field]}
              label={col.title}
              disabled={(disableStart && !disableStop) || !row.product_name}
              onChange={(e) => handleChange(idx, col.field, e.target.value)}
            >
              {uomQuantities.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </TableBodyCell>
        )
      }
      if (col.fieldType === 'datetime') {
        return (
          <TableBodyCell key={col.field}>
            <StyledDateTimePicker
              placeholder={col.title}
              popup={CustomPopup}
              value={row[col.field] || null}
              onChange={(e) => handleChange(idx, col.field, e?.value || null)}
              format='dd/MM/yyyy HH:mm'
              size='small'
              onBlur={() => onBlur(idx)}
              name={col.field}
              disabled={!disableStart || !disableStop || !row.product_name}
            />
          </TableBodyCell>
        )
      }
      return (
        <TableBodyCell key={col.field} minWidth={col.width}>
          <StyledTextField
            placeholder={col.title}
            name={col.field}
            size='small'
            fullWidth
            value={row[col.field]}
            onBlur={() => onBlur(idx)}
            disabled={(disableStart && !disableStop) || !row.product_name}
            onChange={(e) => handleChange(idx, col.field, e.target.value)}
          />
        </TableBodyCell>
      )
    })}
  </TableRow>
)
